<template>
  <form @submit.prevent="handleSubmit">
    <h2>Terminé !</h2>
    <label for="email">Entrez votre adresse mail pour recevoir notre estimation</label>
    <div class="inputs">
      <input
        id="email"
        v-model="email"
        :disabled="disableActions"
        :class="{ invalid: emailIsValid === false, valid: emailIsValid }"
        name="email"
        type="email"
        placeholder="votre adresse email"
      />
      <input :disabled="disableActions" type="submit" class="btn btn-success" value="Recevoir mon estimation" />
    </div>
    <small>Vos données ne seront pas transmises</small>
  </form>
</template>

<script>
export default {
  name: 'Subscribe',
  props: {
    listId: {
      type: String,
      required: true
    },
    surveyId: {
      type: String,
      required: true
    },
    estimatedPrice: {
      type: Number,
      required: true,
      validator(val) {
        return val >= 0
      }
    },
    subscribePostUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      email: '',
      disableActions: false
    }
  },
  computed: {
    emailIsValid() {
      if (this.email.length === 0) return null
      return /^[^@\s]+@[^@\\s]+$/i.test(this.email)
    }
  },
  methods: {
    handleSubmit(event) {
      if (!this.emailIsValid) return

      this.disableActions = true
      fetch(this.subscribePostUrl, {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          email: this.email,
          estimated_price: this.estimatedPrice,
          list_id: this.listId,
          survey_id: this.surveyId
        })
      }).then(
        () => {
          this.$emit('done')
        },
        err => {
          console.error(err)
          this.$emit('done')
        }
      )
    }
  }
}
</script>

<style scoped>
form {
  text-align: center;
  padding: 64px 0;
}

h2 {
  color: rgba(0, 0, 0, 0.38);
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;
  margin: 0 0 32px;
}

label {
  display: block;
  font-size: 1.1rem;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
}

.inputs {
  width: 50%;
  margin: 0 auto;
}

input[type='email'] {
  display: block;
  font-size: 1rem;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.87);
  width: 100%;
  padding: 0.5rem 1rem;
  margin: 1rem auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 2px solid rgba(0, 0, 0, 0.06);
  border-radius: 2px;
  box-sizing: border-box;
}

input[type='email']:focus {
  color: rgba(0, 0, 0, 0.87);
  background-color: #fff;
  border-color: rgb(83, 167, 224);
  outline: 0;
}

input[type='email'].invalid {
  border-color: rgb(255, 77, 112);
}

input[type='email'].valid {
  border-color: rgb(60, 192, 180);
}

input[type='email']:disabled {
  background-color: rgb(0, 0, 0, 0.03);
  border-color: rgba(0, 0, 0, 0.06);
  opacity: 1;
  cursor: not-allowed;
}

input[type='email']::placeholder {
  color: rgba(0, 0, 0, 0.38);
  opacity: 1;
}

input[type='submit'] {
  width: 100%;
}

small {
  color: rgba(0, 0, 0, 0.38);
  font-style: italic;
}
</style>
